import {
    changeTextColor,
    changeNoSubkeyBGColor,
    changeBorderColor
} from "../../data/tableFunc";
import {
    BGDefaultColor,
    BGDisabledColor,
    BorderDefaultColor,
    BorderHoverColor,
    BorderFocusedColor,
    BorderErrorColor
} from "../../data/table";
// TextFieldスタイル調整

// テキストフィールドが非活性で項目色動的対応しない
export const inactiveTextSx = {
    "& .MuiOutlinedInput-input": {
        color: BGDisabledColor,
        textAlign: "center" //入力した値を中央寄せ
    },
    //非活性のため背景がグレー
    "& .Mui-disabled.MuiInputBase-root": {
        backgroundColor: BGDisabledColor,
        "&: hover": {
            backgroundColor: BGDisabledColor
        }
    }
};

// テキストフィールドが非活性で項目色動的対応する
export const inactiveBlueTextSx = (
    objRrBranchLog: any,
    pageName: string,
    labelName: string
) => {
    //テキストカラー
    const color = changeTextColor(true, objRrBranchLog, pageName, labelName); //非活性がtrue 活性がfalse
    return {
        "& .MuiOutlinedInput-input": {
            color: color,
            textAlign: "center", //入力した値を中央寄せ
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            WebkitTextFillColor: color
        },
        //非活性のため背景がグレー
        "& .Mui-disabled.MuiInputBase-root": {
            backgroundColor: BGDisabledColor,
            "&: hover": {
                backgroundColor: BGDisabledColor
            }
        }
    };
};

//カレンダーテキストフィールド
//表紙ページ(契約予定日、開店予定日）
//出店条件ページ(実績取得期間)
export const calendarTextSx = (
    isUserType: boolean,
    objRrBranchLog: any,
    objRequestErrorList: any,
    listDeficiencyComment: any,
    pageName: string,
    labelName: string,
    value: any
) => {
    //テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        pageName,
        labelName
    );
    //背景
    const backgroundColor = changeNoSubkeyBGColor(
        isUserType,
        objRequestErrorList,
        pageName,
        labelName,
        value
    );
    //枠線
    const hasBorderColor = changeBorderColor(
        listDeficiencyComment,
        pageName,
        labelName
    );
    return {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,
                borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
            },
            "&:hover fieldset": {
                borderColor: hasBorderColor ? BorderErrorColor : BorderHoverColor,    //ホバー時
                borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
            },
            "&.Mui-focused fieldset": {
                borderColor: hasBorderColor ? BorderErrorColor : BorderFocusedColor,  //フォーカス時
                borderWidth: hasBorderColor ? "3pt" : "2pt"                           //線の幅調整
            }
        },
        "& .MuiOutlinedInput-input": {
            color: color,
            textAlign: "center" //入力した値を中央寄せ
        },
        "& .MuiInputBase-root.MuiOutlinedInput-root": {
            backgroundColor: backgroundColor
        },
    };
};

//ユーザー権限種別が活性の場合にテキストフィールドの色を変える
export const activeInactiveTextSx = (isUserType: boolean)  => {
    return {
        '& .MuiFilledInput-input' : {
            color: isUserType ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0)',
            textAlign: 'center', //入力した値を中央寄せ
            paddingTop: '17px',
            paddingBottom: '17px'
        },
        //readOnlyがtrueのとき背景がグレー系、色を変える
        '& .MuiInputBase-root.MuiFilledInput-root' : {
            backgroundColor: isUserType ? BGDisabledColor : BGDefaultColor, 
        }
    }
};